import { registerPlugin } from '@capacitor/core';

interface SwipeNavigationPlugin {
  enable(): void;
  disable(): void;
}

interface WebViewBackgroundPlugin {
  pluginVersion(): Promise<string>;
  /**
   * Set the background color of the webview.
   *
   * @since 1.0.0
   * @param options.color Must be a `#rrggbb` or `#rrggbbaa` hex string.
   */
  setBackgroundColor(options: { readonly color: string }): Promise<void>;
}

// Disabling lint rule here to enable the below plugin to align with the
// conventions of naming Capacitor plugins.
// eslint-disable-next-line @typescript-eslint/naming-convention
export const SwipeNavigation =
  registerPlugin<SwipeNavigationPlugin>('SwipeNavigation');

export const WEB_VIEW_BACKGROUND_PLUGIN_NAME = 'WebViewBackground';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const WebViewBackground = registerPlugin<WebViewBackgroundPlugin>(
  WEB_VIEW_BACKGROUND_PLUGIN_NAME,
);
